<template>
  <header class="header">
    <div class="logo">
      <router-link to="/aboutpage">
        <img src="/assets/svgs/logo.svg" alt="Logo" />
      </router-link>
    </div>
    <Menu />
  </header>
</template>

<script>
import Menu from "./MenuBar.vue";
export default {
  components: {
    Menu,
  },
};
</script>